import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/refund-policy")({
  head: () => ({
    meta: [
      { title: "ClaimGuard | Refund Policy" },
      {
        name: "description",
        content:
          "When refunds are available for Professional AI Review and Full-Service Negotiation.",
      },
      { property: "og:title", content: "ClaimGuard | Refund Policy" },
      {
        property: "og:description",
        content: "When refunds are available for our review and negotiation services.",
      },
      { name: "robots", content: "index,follow" },
      { property: "og:url", content: "https://smart-invoice-ally.lovable.app/refund-policy" },
    ],
    links: [{ rel: "canonical", href: "https://smart-invoice-ally.lovable.app/refund-policy" }],
  }),
  component: RefundPolicyPage,
});

function RefundPolicyPage() {
  return (
    <LegalPage
      eyebrow="Billing"
      title="Refund Policy"
      updated="July 5, 2026"
      intro="We want you to feel confident using ClaimGuard. This policy explains when refunds are available for each of our services and how to request one."
      sections={[
        {
          heading: "Professional AI Review",
          body: (
            <p>
              If your report cannot be delivered because of a platform error or unreadable
              upload that we're unable to process, contact support within 14 days of
              payment and we will issue a full refund. Once a report has been delivered,
              the fee is non-refundable, since the work has been performed.
            </p>
          ),
        },
        {
          heading: "Full-Service Negotiation",
          body: (
            <>
              <p>
                Full-Service Negotiation pricing is provided after your Professional AI Review
                is complete. Any amount you pay is refundable in full if you cancel before a
                specialist has begun vendor outreach on your behalf. Once outreach has
                started, that amount is non-refundable.
              </p>
              <p>
                Your quote is confirmed in writing before any charge is made, so there are no
                surprise fees.
              </p>
            </>
          ),
        },
        {
          heading: "Duplicate or accidental charges",
          body: (
            <p>
              Duplicate or clearly accidental charges are refunded in full. Please reach
              out to support with the billing record ID and we will process the refund
              through our payment provider.
            </p>
          ),
        },
        {
          heading: "How to request a refund",
          body: (
            <p>
              Email{" "}
              <a className="text-trust underline" href="mailto:billing@invoiceintelligence.com">
                billing@invoiceintelligence.com
              </a>{" "}
              with your account email, file number, and a brief description. Approved
              refunds typically appear on your statement within 5–10 business days,
              depending on your bank or card issuer.
            </p>
          ),
        },
      ]}
    />
  );
}
